/**
 * Styled Components - Created by cazarez on 10/05/18.
 */
import styled from 'styled-components'
import Button from 'antd/lib/button'
import Popover from 'antd/lib/popover'
import { WHITE, BLUE, GRAY_LIGHT, GRAY_DARK, RED, GREEN, GRAY_SOFT, GOLD_LIGHT } from '../../theme/colors'
import Icon from 'antd/lib/icon'

interface TotalProps {
  onlyRead?: boolean
  simpleDesign?: boolean
  withoutMarginBottom?: boolean
  showCouponInput?: boolean
}

export const Container = styled.div`
  position: relative;
  ${({ showCouponInput }: TotalProps) => showCouponInput ? `
    box-shadow: 0px 2px 7px -1px lightgrey;
    padding: 14px 19px;
    border-radius: 10px;
  ` : ''}
  @media (max-width: 480px) {
    margin-top: 30px;
  }
`

export const Text = styled.div`
  color: ${WHITE};
`
export const ButtonWrapper = styled.div`
  margin-bottom: 10px;
  .ant-btn-primary {
    background-color: ${BLUE};
    border-color: ${BLUE};
    width: 100%;
  }
  .ant-btn-primary:hover {
    background-color: ${BLUE};
    border-color: ${BLUE};
  }
`
export const CheckoutButton = styled(Button)`
  height: 40px;
  width: 100%;
`

export const SummaryTitle = styled.div`
  color: ${GRAY_DARK};
  font-size: 16px;
  font-weight: 600;
  height: 25px;
  letter-spacing: 0.11px;
  line-height: 22px;
  margin-bottom: 25px;
  display: inline-flex;
  justify-content: space-between;
  width: 100%;
`

export const TitleDiv = styled.div`
  display: inline-flex;
`

export const FlagIcon = styled.img`
  max-width: 22px;
  margin-top: -3px;
  border-radius: 3px;
`

export const FlagIconButton = styled.img`
  max-width: 22px;
  margin-top: -3px;
  border-radius: 3px;
  &:hover { 
    cursor: pointer;
  }
`

export const Option = styled.div`
  display: flex;
  align-items: center;
`

export const MenuOption = styled.div`
  color: #5f6062;
  margin-left: 12px;
  font-size: 14px;
  line-height: 22px;
`

interface DividerProps {
  withMargin?: boolean
}

export const Divider = styled.div`
  box-sizing: border-box;
  height: 1px;
  width: 100%;
  background-color: ${GRAY_LIGHT};
  margin-bottom: ${({ withMargin }: DividerProps) =>
    withMargin ? '10px' : '0'};
`

interface DisplayProps {
  hide?: boolean
  secondary?: boolean
  crossed?: boolean
}

export const OrderItem = styled.div`
  display: ${({ hide }: DisplayProps) => (hide ? 'none' : 'flex')};
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 10px;

  color: ${({ secondary }: DisplayProps) => secondary ? GREEN : GRAY_DARK};
  font-size: 16px;
  letter-spacing: 0.11px;
  line-height: 22px;
`

export const ShippingValue = styled.div`
  text-decoration: ${({ crossed }: DisplayProps) => crossed ? 'line-through' : 'unset'};
`

export const FlexWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const TaxDiv = styled.div`
  display: flex;
  font-size: 16px;
  letter-spacing: 0.11px;
  line-height: 22px;
  color: ${GRAY_DARK};
  #vatDesc {
    font-size: 12px;
    margin-left: 6px;
    color: darkgray;
    @media (max-width: 1440px) and (min-width: 768px) {
      position: absolute;
      margin-top: 14px;
      margin-left: 0;
    }
  }
`

export const PercentDiv = styled.div`
  margin-left: 10px;
  color: ${GRAY_SOFT};
  font-size: 14px;
`

export const DeleteLabel = styled.div`
  color: ${RED};
  font-size: 12px;
  letter-spacing: 0.09px;
  line-height: 16px;
  margin-left: 10px;
  cursor: pointer;
`

export const TotalOrderItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: ${({ withoutMarginBottom }: TotalProps) =>
    withoutMarginBottom ? '4px' : '20px'};
  margin-top: ${({ onlyRead, showCouponInput }: TotalProps) =>
    onlyRead || !showCouponInput ? '10px' : '0'};
  color: ${GRAY_DARK};
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.11px;
  line-height: 22px;
  ${({ simpleDesign }: TotalProps) => !simpleDesign ? `
    color: #83b37b;
    padding: 6px 10px;
    border-radius: 5px;
    border: 1px solid;
  ` : ''}
`

export const InvoiceLink = styled.a`
  width: 110px;
  display: flex;
  margin-top: 24px;
  margin-bottom: 12px;
  justify-content: space-between;
  align-items: center;
  color: ${BLUE};
  transition: all .25s;
  &:hover {
    i {
      color: ${RED} !important;
    }
    color: ${RED} !important;
    text-decoration: underline;
  }
`

export const InvoiceIcon = styled(Icon)`
  margin-bottom: 1px;
  color: ${BLUE};
  font-size: 16px;
  transition: all .25s;
`

export const YouSavedOrderItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 10px;
  margin-top: ${({ onlyRead }: TotalProps) => (onlyRead ? '10px' : '0')};
  color: ${RED};
  font-size: 16px;
  letter-spacing: 0.2px;
  line-height: 22px;
`

export const ZipCodeInputWrapper = styled.div`
  margin-bottom: 10px;
  input {
    border-radius: 0;
  }
  .ant-btn {
    border-radius: 0;
    background-color: ${BLUE};
    border-color: ${BLUE};
    &:hover {
      background-color: ${BLUE};
      border-color: ${BLUE};
    }
  }
`

export const CouponIcon = styled(Icon)`
  margin-left: -3px;
  color: ${BLUE};
`

export const SummaryIcon = styled(Icon)`
  margin-right: 10px;
  font-size: 18px;
  color: ${BLUE};
`

export const CollapseWrapper = styled.div`
  margin-bottom: 10px;
  .ant-collapse .ant-collapse-item .ant-collapse-header {
    display: flex;
    flex-direction: row;
    color: ${GRAY_DARK};
    font-size: 12px;
    letter-spacing: 0.15px;
    line-height: 16px;
    padding: 14px 0 12px 0;
  }
  .ant-collapse .ant-collapse-item .ant-collapse-header .arrow {
    position: absolute;
    left: 95%;
    display: inline;
    width: auto;
  }
  .ant-collapse-content > .ant-collapse-content-box {
    padding: unset;
    padding-top: 4px;
    padding-bottom: 16px;
  }

  .ant-collapse-borderless .ant-collapse-item .ant-collapse-content {
    padding: 0 0 0 0;
  }
`
export const CalculationsWrapper = styled.div`
  display: 'flex';
  flex-direction: column;
`

export const DiscountAmout = styled.div`
  color: ${RED};
`

export const CouponName = styled.div`
  font-weight: 600;
`

export const BalanceDue = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 14px;
  font-size: 14px;
  background: #fae3d7;
  padding: 6px 10px;
  border-radius: 3px;
`

export const ShippingLabel = styled.div`
  display: flex;
  align-items: flex-end;
`

export const StyledShippingValue = styled.div`
  text-decoration: ${({ crossed }: DisplayProps) => crossed ? 'line-through' : 'unset'};
`

export const BulkShipTag = styled.div`
  background: ${GOLD_LIGHT};
  line-height: normal;
  border-radius: 5px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  padding: 3px;
  width: 100%;
  max-width: 104px;
  height: auto;
  position: relative;
`

export const StyledTooltip = styled(Popover)``

export const TooltipContent = styled.div`
  max-width: 500px;
  @media (max-width: 698px) {
    #contentBulk {
      flex-flow: column-reverse;
    }
  }
`

export const ImportantNotice = styled.div`
  text-align: center;
  font-weight: bold;
  font-size: 16px;
`

export const BulkShipTitle = styled.div`
  color: #2DC75C;
  font-weight: bold;
  text-align: center;
`

export const BulkShipIcon = styled.img`
  max-width: 140px;
`

export const InfoIcon = styled.img`
  height: 16px;
  position: absolute;
  right: 0px;
  top: -13px;
  z-index: 9;
  filter: brightness(140%) saturate(200%) drop-shadow(0px 2px 2px ${GRAY_DARK});
  animation: wobble-hor-bottom 1s 1s 4 both;
  @keyframes wobble-hor-bottom {
    0%, 20%, 50%, 80%, 100% {transform: translateY(0);}
    40% {transform: translateY(-15px);}
    60% {transform: translateY(-7px);}
  }
`

export const BulkShipDescription = styled.div`
  margin-top: 14px;
  line-height: 20px;
`

export const BulkShipTagIcon = styled.img`
  width: 15px;
`

export const BulkShipTagDescription = styled.p`
  font-size: 10px;
  font-weight: normal;
  margin 0;
  white-space: no-wrap;
`

export const ShippingPrint = styled.div`
  display: flex;
  font-size: 11px;
  margin-left: 9px;
  color: #818181;
  margin-bottom: -1px;
`

export const DesignCheckDiv = styled.div`
  display: flex;
  align-items: center;
`

export const PrintTag = styled.div`
  border-radius: 3px 4px 4px 3px;
  background: #f1f1f1;
  position: relative;
  padding: 3px 6px;
  padding-left: 4px;
  margin-left: 18px;
  display: flex;
  &:before {
    content: "";
    position: absolute;
    display: block;
    left: -10px;
    width: 0;
    height: 0;
    top: 0px;
    border-top: 11px solid transparent;
    border-bottom: 10px solid transparent;
    border-right: 11px solid #f1f1f1;
  }
`

export const PrintIcon = styled.img`
  max-width: 15px;
  opacity: 0.7;
`

export const CircleIcon = styled(Icon)`
  font-size: 13px;
  opacity: 0.85;
  margin-left: 18px;
  padding: 4px 6px;
  border-radius: 3px 4px 4px 3px;
  background: #f1f1f1;
  position: relative;
  padding-left: 4px;
  &:before {
    content: "";
    position: absolute;
    display: block;
    left: -10px;
    width: 0;
    height: 0;
    top: 0px;
    border-top: 11px solid transparent;
    border-bottom: 10px solid transparent;
    border-right: 11px solid #f1f1f1;
  }
`

export const FinalPriceLabel = styled.div`
  text-align: center;
  color: #32a77f;
  font-style: italic;
  img {
    max-width: 16px;
    margin-right: 6px;
    vertical-align: top;
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/OrderSummary/styledComponents.tsx